import { Breadcrumb, ContentLayout, NavPills, NavTab } from '@hyperflake/react-ui-library';
import useClientData from 'modules/clients/hooks/useClientData';
import useProjectData from 'modules/projects/hooks/useProjectData';
import ProjectHierarchyBreadcrumb from 'modules/shared/components/ProjectHierarchyBreadcrumb/ProjectHierarchyBreadcrumb';
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';

const ProjectLayout = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { clientId, projectId } = useParams();

    const { project } = useProjectData(clientId, projectId);
    const { client } = useClientData(clientId);

    const navItems = [
        {
            content: 'Project Details',
            href: `/clients/${clientId}/projects/${projectId}/project-details`,
            isActive: pathname.startsWith(`/clients/${clientId}/projects/${projectId}/project-details`),
        },
        {
            content: 'Project Map',
            href: `/clients/${clientId}/projects/${projectId}/project-map`,
            isActive: pathname.startsWith(`/clients/${clientId}/projects/${projectId}/project-map`),
        },
        {
            content: 'TimeLapse Camera',
            href: `/clients/${clientId}/projects/${projectId}/cameras`,
            isActive: pathname.startsWith(`/clients/${clientId}/projects/${projectId}/cameras`),
        },
        {
            content: 'Live Camera',
            href: `/clients/${clientId}/projects/${projectId}/cctv-cameras`,
            isActive: pathname.startsWith(`/clients/${clientId}/projects/${projectId}/cctv-cameras`),
        },
        {
            content: 'Site Gallery',
            href: `/clients/${clientId}/projects/${projectId}/site-galleries`,
            isActive: pathname.startsWith(`/clients/${clientId}/projects/${projectId}/site-galleries`),
        },
        {
            content: 'Drone',
            href: `/clients/${clientId}/projects/${projectId}/drones`,
            isActive: pathname.startsWith(`/clients/${clientId}/projects/${projectId}/drones`),
        },
        {
            content: 'Links',
            href: `/clients/${clientId}/projects/${projectId}/links`,
            isActive: pathname.startsWith(`/clients/${clientId}/projects/${projectId}/links`),
        },
        {
            content: 'Site Walk',
            href: `/clients/${clientId}/projects/${projectId}/floor-plan`,
            isActive: pathname.startsWith(`/clients/${clientId}/projects/${projectId}/floor-plan`),
        },
    ];

    return (
        <div className="min-h-screen">
            <div className="p-3">
                <ProjectHierarchyBreadcrumb
                    appendItems={[
                        { label: 'Client', to: '/' },
                        { label: client?.name, to: `/clients/${client?._id}/client-details` },
                    ]}
                />

                {/* Scrollable pills on mobile */}
                <div className="mt-4 overflow-x-auto no-scrollbar -mx-3 px-3 lg:overflow-visible lg:mx-0 lg:px-0 snap-x snap-mandatory">
                    <NavPills
                        className="whitespace-nowrap inline-flex gap-2 snap-x"
                        items={navItems.map((item) => ({
                            content: (
                                <Link to={item.href} className="snap-start">
                                    {item.content}
                                </Link>
                            ),
                            isActive: item.isActive,
                            onClick: () => navigate(item.href),
                        }))}
                    />
                </div>
            </div>

            <Outlet />
        </div>
    );
};

export default ProjectLayout;
